import React from 'react';
import { Button } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import { useStatus } from '../hooks';

const Status = () => {
  const { handleSetStatus, statusState } = useStatus();

  return (
    <Button variant="outlined" disabled={statusState.loading} onClick={handleSetStatus} endIcon={<Check />}>
      Status
    </Button>
  );
};

export default Status;
